export const ATTENDANRCONTRACTLIST_SEARCH = 'ATTENDANRCONTRACTLIST_SEARCH';
export const ATTENDANRCONTRACTLIST_PAGE = 'ATTENDANRCONTRACTLIST_PAGE';
export const ATTENDANRCONTRACTLIST_WEEK = 'ATTENDANRCONTRACTLIST_WEEK';
export const ATTENDANRCONTRACTLIST_YEAR = 'ATTENDANRCONTRACTLIST_YEAR';
export const ATTENDANRCONTRACTLIST_TOYEAR = 'ATTENDANRCONTRACTLIST_TOYEAR';
export const ATTENDANRCONTRACTLIST_TOWEEK = 'ATTENDANRCONTRACTLIST_TOWEEK';
